export default __webpack_public_path__ + "static/media/P10004.c30b0df1.png";